import { Box, Grid } from "@mui/material";
import { convertToJalali } from "../../../utils/date";
import { useTranslation } from "react-i18next";

//import utils
import { numberWithCommas } from "../../../utils/utility";

//import images and icons
import { Airplane } from "iconsax-react";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";

// import styles
import "./confirm.scss";

function BusInformation({ title, selectedBus, iconName, newPrice }) {
    //general variables
    const { t } = useTranslation();

    const { company_name, origin, destination, move_date, move_time } = selectedBus ?? {};

    const informationList = [
        { id: 1, title: "مسافربری", value: company_name },
        { id: 2, title: t("departure"), value: origin?.name },
        { id: 3, title: t("destination"), value: destination?.name },
        { id: 4, title: "پایانه مبدا", value: origin?.terminal },
        { id: 5, title: "پایانه مقصد", value: destination?.terminal },
        { id: 6, title: t("departureTimeDate"), value: `${move_time} | ${move_date.replaceAll("-", "/")}` },
    ];

    return (
        <Box sx={{ maxWidth: 900, mx: "auto", px: { xs: 1, sm: 2 }, py: 3, display: "flex", alignItems: "center", flexDirection: "column" }}>
            <Grid className={`confirm__title ${iconName}`} container item xs={6} justifyContent="center">
                <DirectionsBusFilledIcon sx={{ color: "var(--light-color)" }} />
                بلیط
            </Grid>

            <Grid className="confirm" container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start">
                {informationList.map(information => {
                    return (
                        <Grid
                            key={information?.id}
                            className="confirm__information"
                            container
                            item
                            xs={12}
                            justifyContent="space-between"
                            mx={{ xs: 2.5, xl: 0 }}
                        >
                            <span>{information.title}</span>
                            <span>{information.value}</span>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
}

export default BusInformation;
